import { createFileRoute, redirect } from "@tanstack/react-router";

import { getAccessToken } from "../auth";
import { LoginPage } from "../pages/login-page";

export const Route = createFileRoute("/login")({
  validateSearch: (input: Record<string, unknown>) => ({
    activated: input.activated === true || input.activated === "true",
  }),
  beforeLoad: () => {
    if (getAccessToken()) throw redirect({ to: "/app/overview" });
  },
  component: () => <LoginPage activated={Route.useSearch().activated} />,
});
